import React, { useEffect } from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";
import { useDispatch } from "react-redux";
import { resetResponseStatus } from "store/session/action";
import { toggleImgLoadingState } from "store/camera/mediafiles/action";

function Error404() {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(toggleImgLoadingState(false));
  }, []);
  return (
    <Container>
      <h2>Not Found</h2>
      <Description>該当のページは存在しない、または削除されました</Description>
      <BackLink to="/" onClick={() => dispatch(resetResponseStatus())}>
        TOPにもどる
      </BackLink>
    </Container>
  );
}

export default Error404;

const Container = styled.div`
  padding: 30px;
`;

const Description = styled.p`
  margin-bottom: 1rem;
`;

const BackLink = styled(Link)`
  font-weight: bold;
  &:hover {
    opacity: 0.6;
  }
`;
